import axios from '@/utils/request'

export default {
  // 2020-08-03
  findByTenantId() {
    return axios.get('/mes/factories/find-by-tenant-id')
  },

  // 2020-08-04
  findPhases(id) {
    return axios.get('/mes/factories/' + id + '/phases')
  },
  // 2020-08-06
  update(id, params) {
    return axios.put('/mes/factories/' + id, params)
  },
  // 2020-08-06
  create(params) {
    return axios.post('/mes/factories', params)
  },
  // 2020-08-06
  delete(id) {
    return axios.delete('/mes/factories/' + id)
  },

  // 2020-08-05
  deletePhases(id, phaseId) {
    return axios.delete('/mes/factories/' + id + '/phases/' + phaseId)
  },
  // 2020-08-05
  updatePhases(id, phaseId, params) {
    return axios.put('/mes/factories/' + id + '/phases/' + phaseId, params)
  },
  // 2020-08-05
  createPhases(id, params) {
    return axios.post('/mes/factories/' + id + '/phases', params)
  },

  // 2021-09-09
  copySchedule(id, params) {
    return axios.put('/mes/factories/' + id + '/copy-schedule', params)
  },
  // 2020-08-04
  findById(id) {
    return axios.get('/mes/factories/' + id)
  }

}

